import React, { useState } from "react";
import Partners from "../components/Partners";
import AdvisoryTeam from "../components/AdvisoryTeam";
import OrganisingTeam from "../components/OrganisingTeam";
import Host from "../components/Host";
import CoHost from "../components/CoHost";

const Committee = () => {
  const [active, setActive] = useState(0);
  const tabs = [
    "Advisory Committee",
    "Organising Committee",
    "Host and Co-Host",
    "Sponsors",
  ];

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="min-h-screen p-5 flex flex-col md:flex-row">
      {/* Sidebar */}
      <div className="md:w-1/4 w-full bg-white shadow-md p-6 md:sticky md:top-20 h-fit">
        {tabs.map((tab, index) => (
          <div
            key={`tab-${index}`}
            onClick={() => {
              setActive(index);
              scrollToTop();
            }}
            className={`cursor-pointer py-4 px-4 hover:underline ${
              active === index ? "text-light-orange border-l-4 border-light-orange" : ""
            }`}
          >
            <span className="text-xl md:text-2xl font-bold">{tab}</span>
          </div>
        ))}
      </div>

      {/* Content Section */}
      <div className="md:w-3/4 w-full mt-4 md:mt-0">
        <section className={`${active !== 0 ? "hidden" : ""}`}>
          <h1 className="text-4xl font-extrabold text-blue-900 text-center mt-12 mb-8">Advisory Committee</h1>
          <AdvisoryTeam />
        </section>

        <section className={`${active !== 1 ? "hidden" : ""}`}>
          <h1 className="text-4xl font-extrabold text-blue-900 text-center mt-12 mb-8">Organising Committee</h1>
          <OrganisingTeam />
        </section>

        <section className={`${active !== 2 ? "hidden" : ""}`}>
          <h1 className="text-4xl font-extrabold text-blue-900 mt-12 mb-8">Host</h1>
          <Host />
          <h1 className="text-4xl font-extrabold text-blue-900 mt-12 mb-8">Co-Host</h1>
          <CoHost />
        </section>

        <section className={`${active !== 3 ? "hidden" : ""}`}>
          <h1 className="text-4xl font-extrabold text-blue-900 mt-12 mb-8">Sponsors</h1>
          <Partners />
        </section>
      </div>
    </div>
  );
};

export default Committee;